<template>
  <div id="app">
    <!-- <navbar></navbar> -->
    <router-view/>
    <Footer></Footer>
    <!-- <footer></footer> -->
  </div>
</template>

<script>
import './assets/libraries/bootstrap/js/jquery-3.1.1.min.js'
import './assets/libraries/bootstrap/js/bootstrap.min.js'
import './assets/js/main1.js'
// import navbar from './components/navbar';
import Footer from './components/Footer';
export default {
  name: 'App',
  components: {
    // navbar,
    Footer,
  },
}
</script>

<style>
@import './assets/libraries/bootstrap/css/bootstrap.min.css';
@import './assets/css/main.css';
@import './assets/css/index.css';
@import url("https://fonts.googleapis.com/css?family=Roboto&display=swap");
</style>



// WEBPACK FOOTER //
// src/App.vue